import React, { useEffect, useRef, useState } from "react";
import { useSubheader } from "../../../_metronic/layout";
import { Checkbox, Paper, Table, TableBody, TableCell, TableRow, TablePagination, TextField, IconButton, Popover, Typography } from "@material-ui/core";
import { Dropdown, Button } from "react-bootstrap";
import EnhancedTableHead from "../../components/EnhancedTableHead";
import makeRequest from "../../api/makeRequest";
import { Link } from "react-router-dom";
import { DropdownCustomToggler } from "../../../_metronic/_partials/dropdowns";
import { DashboardRoomMenu } from "../../../_metronic/_partials/dropdowns/DashboardRoomMenu";
import { useTranslation } from "react-i18next";
import apiConfig from "../../config/apiConfig";
import { Share as ShareIcon, Visibility as VisibilityIcon } from "@material-ui/icons";
import moment from "moment-jalaali";
import MyModal from "../../components/MyModal";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import faker from '@faker-js/faker';

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend
);

export const RoomAttendancePage = ({ match }) => {
	const { t } = useTranslation('common');
	const headRows = [
		{ id: "id", disablePadding: true, label: t('Id') },
		{ id: "name", disablePadding: false, label: t('Name') },
		{ id: "firstLogin", disablePadding: false, label: t('FirstLogin') },
		// {id: "role", disablePadding: false, label: t('Role')},
		{ id: "percent", disablePadding: false, label: t('AttendancePercent') },
		{ id: "operation", disablePadding: false, label: t('Operations') }
	];
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('Attendance'));

	const [Connections, setConnections] = useState([])
	const [RoomSession, setRoomSession] = useState({})
	const [selectedUser, setSelectedUser] = useState(null)
	const [selected, setSelected] = React.useState([]);
	const [orderBy, setOrderBy] = React.useState("_id");
	const [order, setOrder] = React.useState("desc");
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(25);
	const [totalDocs, setTotalDocs] = React.useState(0);

	const [search, setSearch] = useState({})
	const [requestSearch, setRequestSearch] = useState(false)

	const [OpenShare, setOpenShare] = useState(0)
	const [anchorEl, setAnchorEl] = useState(null);

	useEffect(() => {
		moment.loadPersian();
	}, [])
	useEffect(() => {
		const getRoomAttendance = async () => {
			try {
				const query = {
					page: page + 1,
					per_page: rowsPerPage
				}
				const { data } = await makeRequest('getRoomAttendance', { id: match.params.sid, search }, query)
				const connections = data.connections.docs
				const roomSession = data.connections.roomSession
				setConnections(connections)
				setRoomSession(roomSession)
				setTotalDocs(data.connections.totalDocs)
			} catch (e) {
				console.log(e)
			}
		}

		getRoomAttendance()

	}, [page, rowsPerPage, requestSearch, match])



	function handleSelectAllClick(event) {
		if (event.target.checked) {
			const newSelecteds = Connections.map(n => n.name);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	}

	function handleRequestSort(event, property) {
		const isDesc = orderBy === property && order === "desc";
		setOrder(isDesc ? "asc" : "desc");
		setOrderBy(property);
	}

	function stableSort(array, cmp) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = cmp(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map(el => el[0]);
	}

	function desc(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getSorting(order, orderBy) {
		return order === "desc"
			? (a, b) => desc(a, b, orderBy)
			: (a, b) => -desc(a, b, orderBy);
	}

	const isSelected = name => selected.indexOf(name) !== -1;

	function handleClick(event, name) {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}

		setSelected(newSelected);
	}

	const emptyRows =
		rowsPerPage - Math.min(rowsPerPage, Connections.length - page * rowsPerPage);

	function handleChangePage(event, newPage) {
		setPage(newPage);
	}

	function handleChangeRowsPerPage(event) {
		setPage(0)
		setRowsPerPage(parseInt(event.target.value, 10));
	}

	function random_rgba() {
		var o = Math.round, r = Math.random, s = 255;
		//+ ',' + r().toFixed(1)
		return 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ', 0.6)';
	}

	const handleSelectAttendance = (row) => {
		const options = {
			responsive: true,
			plugins: {
				legend: {
					position: 'top',
				},
				title: {
					display: true,
					text: t('Attendance'),
				},
			},
		};

		const labels = [`${t('Connections')}(${t('Minutes')})`];

		const data = {
			labels,
			datasets: (row?.userSessionInfo?.durations || []).map((q, k) => ({
				label: `${t('Connection')} ${k + 1}`,
				data: [(q / 60).toFixed(1)],
				backgroundColor: random_rgba(),
			}))
		};
		row.options = options;
		row.data = data;
		setSelectedUser(row);
	}

	const handleCloseModal = () => {
		setSelectedUser(null)
	}

	return (
		<>
			<MyModal
				active={selectedUser}
				onClose={handleCloseModal}
				header={t('UserAttendance', { name: selectedUser?.user?.name })}
			>
				{selectedUser ?
					<div className="text-center">
						<h3>{`${t('AttendancePercent')} : ${selectedUser.userSessionInfo.AttendancePercent.toFixed(1)} %`}</h3>
						<h4>{t('AttendanceTime', { time: (selectedUser.userSessionInfo.totalSec / 60).toFixed(1) })} ({t('Minutes')})</h4>
						<Bar options={selectedUser.options} data={selectedUser.data} />
					</div>
					: ''}
			</MyModal>
			{/* <div className="new-room">
				<Link to={'/room/new'}><Button variant="outline-primary mb-5">{t('MENU.NEW')}</Button></Link>
			</div> */}
			{/* <SearchInputs
				onSearch={(e)=>{
					setSearch(e)
					setRequestSearch(prev=>!prev)
				}}
				showReset={JSON.stringify(search) !== "{}"}
			/> */}
			<Paper className={"classes.paper"}>
				<div className={"tableWrapper"}>
					<Table
						className={"classes.table"}
						aria-labelledby="tableTitle"
						size={"medium"}
					>
						<EnhancedTableHead
							numSelected={selected.length}
							order={order}
							orderBy={orderBy}
							onSelectAllClick={handleSelectAllClick}
							onRequestSort={handleRequestSort}
							rowCount={Connections.length}
							headRows={headRows}
						/>
						<TableBody>
							{stableSort(Connections, getSorting(order, orderBy))
								.map((row, index) => {
									const rowId = row?.user?.id + index
									const isItemSelected = isSelected(rowId);
									const labelId = `enhanced-table-checkbox-${index}`;
									// let roleNameKey = '';
									// switch(row?.objectUser?.role){
									// 	case 1:
									// 		roleNameKey = 'StudentRole'
									// 		break;
									// 	case 2:
									// 		roleNameKey = 'ProviderRole'
									// 		break;
									// 	case 3:
									// 		roleNameKey = 'MasterRole'
									// 		break;
									// 	case 4:
									// 		roleNameKey = 'AdminRole'
									// 		break;
									// }

									const totalTimeOfRoomSession = Math.abs((RoomSession?.end_time - RoomSession?.start_time) || 0) //in sec
									const rowConnections = (row?.connections || []).filter(q => q && q.end_time)
									const userSessionInfo = {
										totalConnection: rowConnections.length,
										totalSec: 0,
										durations: []
									}
									rowConnections.forEach(q => {
										const durationOfQ = ((+ new Date(q.end_time)) - (+ new Date(q.start_time))) / 1000
										userSessionInfo.totalSec += durationOfQ;
										userSessionInfo.durations.push(durationOfQ)
									})

									const AttendancePercent = totalTimeOfRoomSession ? (
										(userSessionInfo.totalSec * 100 / totalTimeOfRoomSession)
									) : 0
									userSessionInfo.AttendancePercent = AttendancePercent

									row.userSessionInfo = userSessionInfo;


									return (
										<TableRow
											hover
											onClick={event => handleClick(event, rowId)}
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={rowId}
											selected={isItemSelected}
										>
											<TableCell padding="checkbox">
												<Checkbox
													checked={isItemSelected}
													inputProps={{
														"aria-labelledby": labelId
													}}
												/>
											</TableCell>
											<TableCell
												component="th"
												id={labelId}
												align="right"
											>
												{row?.user?.id}
											</TableCell>
											<TableCell align="right">{row?.user?.name || "Unknowen"}</TableCell>
											<TableCell align="right">{moment.unix(row?.firstLoginAt).format("HH:mm jYYYY/jMM/jDD")}</TableCell>
											{/* <TableCell align="right">{t(roleNameKey)}</TableCell> */}
											<TableCell className='font-size-h2 text-danger' align="right">{`${AttendancePercent.toFixed(1)} %`}</TableCell>
											<TableCell align="right">
												<IconButton onClick={() => handleSelectAttendance(row)} color="primary" component="span">
													<VisibilityIcon />
												</IconButton>
											</TableCell>
										</TableRow>
									);
								})}
							{emptyRows > 0 && (
								<TableRow style={{ height: 49 * 5 }}>
									<TableCell colSpan={6} />
								</TableRow>
							)}
						</TableBody>
					</Table>
				</div>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25, 50, 100]}
					component="div"
					labelRowsPerPage={t('NumberPerPage')}
					count={totalDocs}
					rowsPerPage={rowsPerPage}
					page={page}
					backIconButtonProps={{
						"aria-label": "Previous Page"
					}}
					nextIconButtonProps={{
						"aria-label": "Next Page"
					}}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
			</Paper>
		</>
	);
};

const SearchInputs = React.memo(({ onSearch, showReset = false }) => {
	const [name, setName] = useState('')
	const { t } = useTranslation('common')
	const [id, setId] = useState('')
	return (
		<div className='flex justify-content-between align-items-center my-5'>
			<form onSubmit={(e) => {
				e.preventDefault()
				onSearch({ name, id })
			}}>
				<TextField onChange={(e) => setName(e.target.value)} className='mx-2 my-2' label={t('Name')} variant="outlined" />
				<TextField onChange={(e) => setId(e.target.value)} className='mx-2 my-2' label={t('Id')} variant="outlined" />
				<Button type='submit' className='mx-2 my-2' style={{ lineHeight: "2.6" }}>{t('ECOMMERCE.COMMON.SEARCH')}</Button>
				{showReset ? <Button type='reset' onClick={() => onSearch({})} className='mx-2 my-2' style={{ lineHeight: "2.6" }} variant="outline-danger">{t('RemoveFilter')}</Button> : null}
			</form>

		</div>
	)
})